module.exports = __WEBPACK_EXTERNAL_MODULE_7__;


//////////////////
// WEBPACK FOOTER
// external {"root":["AWSCognito"],"commonjs2":"aws-sdk/global","commonjs":"aws-sdk/global","amd":"aws-sdk/global"}
// module id = 7
// module chunks = 0